export default __webpack_public_path__ + "static/media/CashBack.17b7db3e.svg";